/*
A user can register/login with email / password. This will create a user in the ID database and a JWT session.
A ChessUser in the RedPanda database will be created as well. 
This user can link to an existing federation player, determined by the existance of a FederationNumber.
*/
//import jsonwebtoken from 'jsonwebtoken';
import { reactive } from 'vue';

function createCAUser() {

  const state = reactive({
        msalUser: null,
        chessUser: null,
        chessUserClubs: null,
        loggedIn: false,
        token: "",
        refreshToken: localStorage.getItem('rt') || "",
        userComponent: null,
    });

 /* var _msalUser = null;
  var _chessUser = null;
  var _chessUserClubs = null;
  var _loggedIn = false;
  var _token = "";
  var _userComponent = null;
*/

  const CAUser = {
    /*
    data () { 
      return {
        chessUser: _chessUser, //Chess Administrator registration
        chessUserClubs: _chessUserClubs,
        loggedIn: _loggedIn,
        msalUser: _msalUser,   //Azure login user
        userComponent: _userComponent
      }
    },
    */
    getClubs() {
      if (state.chessUserClubs != null) {
        return state.chessUserClubs;
      } else
        return [];
    },

    setClubs(clubs) {
      state.chessUserClubs = clubs;
    },

    getPersonId() {
      if (state.chessUser != null) {
        return state.chessUser.personId;
      } else
        return -1;
    },

    loggedIn() {
      return state.loggedIn;
    },

    logout() {
      state.loggedIn = false;
      state.chessUser = null;
      state.msalUser = null;
    },

    linked() {
      if (state.chessUser != null) {
        return (state.chessUser.federationNumber != null);
      }
      else return false;
    },

    userAccount() {
      if (state.msalUser != null)
        return state.msalUser.userName;
      else
        return "No external useraccount used";
    },
    
    userName() {
      if (state.chessUser != null)
        return state.chessUser.name;
      else
        return "";
    },

    getChessUser() {
      return state.chessUser;
    },

    setChessUser(user) {
      state.chessUser = user;
      state.loggedIn = true;
      console.log("Setting Chessuser");
      // Let op: 'this' verwijst hier naar het CAUser object
      if (this.userComponent != null) {
        this.userComponent = null;
        console.log("Component updated");
      }
    },

    getMsalUser() {
      return state.msalUser;
    },

    setMsalUser(user) {
      if (user != null) 
        state.loggedIn = true;

      state.msalUser = user;
    },

    getToken() {
      return state.token;
    },

    setToken(token) {
      if (token != null) { 
        //console.log("Token: " + token);

        try {
          // 1. Splits het token in drie delen
          const base64Url = token.split('.')[1];
          // 2. Vervang tekens die niet in Base64 passen
          const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
          // 3. Decodeer de Base64-string naar een normale string
          const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
          }).join(''));
          // 4. Parse de JSON om het object te krijgen
          var jwtToken = JSON.parse(jsonPayload);

          var nu = Math.floor(Date.now() / 1000);
          console.log("Nu: " + nu);
          console.log("Aantal minuten te gaan: " +  ((jwtToken.exp - nu)/60));
          state.token = token;
        } catch (error) {
          console.error("Fout bij het decoderen van JWT of inladen van jwt-decode:", error.message);
          console.error("Stack trace:", error.stack);
        }
      }
    },

    setCallbackUserComponent(component) {
      if (state.chessUser == null)
        console.log("Linking Usercomponent");
        this.userComponent = component;
    },

    // DEZE INSTALL-FUNCTIE IS AANGEPAST VOOR MAXIMALE ROBUUSTHEID
    install(app) {
      // We gebruiken de CAUser variabele uit de outer scope in plaats van 'this'.
      // Dit omzeilt bundelingsproblemen met de 'this' context in productie.
      app.config.globalProperties.$CAUser = CAUser;
    },

    getRefreshToken() {
        return state.refreshToken;
    },

    setRefreshToken(token) {
        state.refreshToken = token;
        localStorage.setItem('rt', token); // Bewaar het zodat F5 de sessie niet verbreekt
    },

    // Controleer of de token nog geldig is voor de komende 60 seconden
    isTokenExpired() {
      console.log("checking token");
      if (!state.token) return true;
      try {
        const base64Url = state.token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const payload = JSON.parse(atob(base64));
        console.log("token: " + JSON.stringify(payload));
        const nu = Math.floor(Date.now() / 1000);
        console.log("nu: " + nu);
        console.log("exp: " + payload.exp);        
        console.log("token over: " + (payload.exp - nu));        
        return (payload.exp - nu) < 60; // verlopen of bijna verlopen
      } catch (e) {
        return true;
      }
    }

  }

  return CAUser;
}

const _createCAUser = createCAUser;
export { _createCAUser as createCAUser };